module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.CompanyID) ? _c('div', {
    staticClass: "CustomerServices"
  }, [_c('div', {
    staticClass: "CustomerServices-wrapper",
    attrs: {
      "id": "CustomerServices"
    },
    on: {
      "touchstart": function($event) {
        return _vm.Touchstart($event)
      },
      "touchmove": function($event) {
        return _vm.Touchmove($event)
      },
      "touchend": function($event) {
        return _vm.Touchend($event)
      }
    }
  }, [_c('ul', {
    staticClass: "CustomerServices-item slidein-spring ",
    class: {
      'showFade': _vm.ShowFadeFlag, 'fadeBottom': _vm.isBottom
    }
  }, [_c('li', {
    staticClass: "CustomerServices-wrap"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.ShowFade($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/mascot.png"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "CustomerServices-list"
  }, [_c('li', {
    staticStyle: {
      "background": "#1CD49E"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/xiaoxi1.png"
    },
    on: {
      "click": _vm.messageNotify
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "background": "#FEAE00"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/feedBack-icon1.png"
    },
    on: {
      "click": _vm.ToFeedBack
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "background": "#B35CFF"
    }
  }, [_c('img', {
    attrs: {
      "id": "btn_udesk_im",
      "src": "/static/img/kefu4.png"
    },
    on: {
      "click": _vm.showUdesk
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "picker-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateServices === 1),
      expression: "stateServices===1"
    }],
    staticClass: "picker",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": _vm.cancel
    }
  }, [_c('transition', {
    attrs: {
      "name": "picker-move"
    }
  }, [(_vm.stateServices === 1) ? _c('div', {
    staticClass: "picker-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "picker-choose border-bottom-1px"
  }, [_c('label', {
    on: {
      "click": _vm.cancel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.14rem"
    },
    attrs: {
      "src": "/static/img/close.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "picker-title"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('system.CustomerService')) + "&" + _vm._s(_vm.$t('system.Sell')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "0.13rem",
      "vertical-align": "text-top"
    },
    attrs: {
      "src": "/static/img/call.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "vertical-align": "text-top"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.ContactUs')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-content",
    staticStyle: {
      "padding": "0 0.1rem"
    }
  }, _vm._l((_vm.Services), function(Service) {
    return (Service.ContactMobile != '') ? _c('div', {
      staticClass: "picker-item"
    }, [_c('div', [_c('span', {
      staticClass: "Service-UserName ellipsis"
    }, [_vm._v(_vm._s(Service.UserName))]), _vm._v(" "), _c('span', {
      staticClass: "Service-Type",
      staticStyle: {
        "vertical-align": "middle"
      },
      style: ({
        'background-color': Service.DepartmentName == _vm.$t('system.ServiceDept') ? '#d1edff' : '#ffe0cc',
        'color': Service.DepartmentName == _vm.$t('system.ServiceDept') ? '#17a5ff' : '#ff6600'
      })
    }, [_vm._v(_vm._s(Service.DepartmentName))])]), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": ("tel:" + (Service.ContactMobile))
      }
    }, [_c('img', {
      staticStyle: {
        "width": "0.13rem",
        "vertical-align": "middle"
      },
      attrs: {
        "src": "/static/img/callb.png"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#666",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm.$t('system.Call')))])])])]) : _vm._e()
  }), 0)]) : _vm._e()])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "explain-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 1),
      expression: "state===1"
    }],
    staticClass: "explain",
    staticStyle: {
      "background": "rgba(255, 255, 255, .85)"
    },
    on: {
      "click": _vm.hide,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  })])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3683d978"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/customer-services.vue
// module id = 552
// module chunks = 62